import {
  AllTranslationsResponseSchema,
  TranslationsSchema,
  type TranslationGroup,
  type Translations,
} from '@/schemas/translation';
import type { Result } from '@/types/api-routes';
import { API_ROUTES, validatedApiRequest } from '@/types/api-routes';

class TranslationService {
  getTranslations(locale: string): Promise<Result<Translations>> {
    return validatedApiRequest(API_ROUTES.translations.for_locale, TranslationsSchema, { locale });
  }

  getAllTranslations(): Promise<Result<TranslationGroup[]>> {
    return validatedApiRequest(API_ROUTES.translations.all, AllTranslationsResponseSchema);
  }
}

export const translationService = new TranslationService();

export { type Translations, type TranslationGroup } from '@/schemas/translation';
